import React from "react";
import PropTypes from "prop-types";
import { Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDTypography from "components/MDTypography";

/**
 * Form fields shared by the Add and Update leader screens.
 *
 * The profile is edited as one text box with paragraphs separated by a blank
 * line; `bioToText` / `textToBio` convert to and from the API's array.
 */
export const bioToText = (bio) => (Array.isArray(bio) ? bio.join("\n\n") : "");

export const textToBio = (text) =>
  String(text || "")
    .split(/\n\s*\n/)
    .map((para) => para.trim())
    .filter(Boolean);

export const emptyLeader = {
  name: "",
  designation: "",
  bio: "",
  sort_order: 0,
  status: "active",
};

export default function LeaderFormFields({ values, onChange }) {
  const handleInput = (e) => onChange(e.target.name, e.target.value);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          type="text"
          label="Name *"
          name="name"
          placeholder="e.g. Mr. Pankaj Sarda"
          onChange={handleInput}
          value={values.name}
          style={{ width: "100%" }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          type="text"
          label="Designation"
          name="designation"
          placeholder="e.g. Promoter & Managing Director"
          onChange={handleInput}
          value={values.designation}
          style={{ width: "100%" }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          type="number"
          label="Display Order"
          name="sort_order"
          helperText="Lower numbers show first on the website"
          inputProps={{ min: 0 }}
          onChange={handleInput}
          value={values.sort_order}
          style={{ width: "100%" }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <InputLabel>Status</InputLabel>
        <Select
          value={values.status}
          onChange={(e) => onChange("status", e.target.value)}
          name="status"
          style={{ width: "100%", height: "45px", color: "#111" }}
        >
          <MenuItem value="active" style={{ color: "#111" }}>
            Active (shown on website)
          </MenuItem>
          <MenuItem value="inactive" style={{ color: "#111" }}>
            Inactive (hidden)
          </MenuItem>
        </Select>
      </Grid>

      <Grid item xs={12}>
        <TextField
          type="text"
          label="Profile"
          name="bio"
          onChange={handleInput}
          value={values.bio}
          style={{ width: "100%" }}
          multiline
          minRows={10}
        />
        <MDTypography variant="caption" color="text">
          Separate paragraphs with a blank line. The website shows the first paragraph
          and reveals the rest behind &quot;View More&quot;.
        </MDTypography>
      </Grid>
    </Grid>
  );
}

LeaderFormFields.propTypes = {
  values: PropTypes.shape({
    name: PropTypes.string,
    designation: PropTypes.string,
    bio: PropTypes.string,
    sort_order: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
